import React from 'react'
import Navbar from '../../components/navbar'
import bg1 from '../../assets/images/bg.jpg'
import { Link } from 'react-router-dom'
import Shape from '../../components/shape'
import ShapeTwo from '../../components/shape-two'
import Footer from '../../components/footer'

export default function PageForgotPassword() {
  return (
    <>
     <Navbar/>
    <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center'}}>
        <div className="bg-overlay bg-overlay-white"></div>
        <div className="container">
            <div className="row mt-5 text-center align-items-center">
                <div className="col-sm-6">
                    <div className="text-sm-start">
                        <div className="page-next-level">
                            <h4 className="title">Forgot Password</h4>
                            <p className="text-muted mb-0">Please enter your email address. You will receive a link to create a new password via email.</p>                                        
                        </div>
                    </div>
                </div>

                <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                    <div className="page-next-level text-sm-end">
                        <ul className="page-next ps-0 mb-0">
                            <li className="list-inline-item"><Link to="/" className="text-uppercase fw-bold text-dark">Home</Link></li>
                            <li className="list-inline-item"><Link to="#" className="text-uppercase fw-bold text-dark">Pages</Link></li>
                            <li className="list-inline-item"><Link to="#" className="text-uppercase fw-bold text-dark">Authentication</Link></li>
                            <li className="list-inline-item">
                                <span className="text-uppercase text-primary fw-bold">Forgot Password</span> 
                            </li> 
                        </ul>
                    </div>
                </div>
            </div>
        </div> 
    </section> 
    <ShapeTwo/>

    <section className="section">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-5 col-md-8">
                    <div className="login_page">
                        <form className="login-form">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="mb-3">
                                        <label className="form-label">Email address <span className="text-danger">*</span></label>
                                        <input type="email" className="form-control" placeholder="Email" name="email" required=""/>
                                    </div>
                                </div>
                                <div className="col-lg-12">
                                    <button className="btn btn-primary w-100">Send</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <Shape/>
    <Footer/>
    </>
  )
}
